import { Typography, Tooltip } from '@mui/material';
import { CheckCircleOutline } from '@mui/icons-material';

import {
  SkillDisplayCard,
  SkillDisplayStack,
  SkillNameText,
  SkillRating,
  EmptyIcon,
} from './ProfessionalBackground.styles';

function SkillDisplay({ skillLevel, skillName, showLevel = true }) {
  const labels = {
    1: 'Novice',
    2: 'Proficient',
    3: 'Expert',
  };

  function getLabelText(value) {
    return `${labels[value]}`;
  }

  const toolTipContent = () => {
    return <Typography variant="body1">{getLabelText(skillLevel)}</Typography>;
  };

  return (
    <SkillDisplayCard>
      <SkillDisplayStack direction="row">
        <SkillNameText>{skillName}</SkillNameText>
        {showLevel && (
          <Tooltip arrow followCursor title={toolTipContent()}>
            <div>
              <SkillRating
                name="skill-level"
                value={skillLevel}
                max={3}
                readOnly
                getLabelText={getLabelText}
                icon={<CheckCircleOutline fontSize="inherit" />}
                emptyIcon={<EmptyIcon fontSize="inherit" />}
              />
            </div>
          </Tooltip>
        )}
      </SkillDisplayStack>
    </SkillDisplayCard>
  );
}

export default SkillDisplay;
